import { useState } from "react";
import "./CreateBlog.css";

const CreateBlog = () => {
  const [form, setForm] = useState({
    title: "",
    excerpt: "",
    content: "",
    status: "draft",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch("https://astrasighttech.com/api/create.php", {
      method: "POST",
      credentials: "include", // 👈 THIS IS THE KEY
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });

    const data = await res.json();

    if (res.ok) {
      alert("Blog created!");
    } else {
      alert(data.error || "Unauthorized");
    }
  } catch (err) {
    console.error(err);
    alert("Server unreachable");
  }
};


  return (
    <div className="blog-wrapper">
      <form className="blog-form" onSubmit={handleSubmit}>
        <h2>Create Blog Post</h2>

        <input
          name="title"
          placeholder="Blog title"
          onChange={handleChange}
        />

        <textarea
          name="excerpt"
          placeholder="Short excerpt"
          rows="3"
          onChange={handleChange}
        />

        <textarea
          name="content"
          placeholder="Blog content..."
          rows="8"
          onChange={handleChange}
        />

        <select name="status" onChange={handleChange}>
          <option value="draft">Draft</option>
          <option value="published">Published</option>
        </select>

        <button type="submit">Save Blog</button>
      </form>
    </div>
  );
};

export default CreateBlog;
